import numeral from 'numeral';

// ----------------------------------------------------------------------

export function fCurrency(number, currency = 'USD') {
  return numeral(number).format(
    Number.isInteger(number)
      ? `
  ${currencyOptions[currency].symbol}0,0
  `
      : `${currencyOptions[currency].symbol}0,0.00`
  );
}

export function fPercent(number) {
  return numeral(number / 100).format('0.0%');
}

export function fNumber(number) {
  return numeral(number).format();
}

export function fShortenNumber(number) {
  return numeral(number).format('0.00a').replace('.00', '');
}

export function fData(number) {
  return numeral(number).format('0.0 b');
}

const currencyOptions = {
  SAR: {
    name: 'Saudi Riyal',
    demonym: 'Saudi',
    majorSingle: 'Riyal',
    majorPlural: 'Riyals',
    ISOnum: 682,
    symbol: 'SR',
    symbolNative: 'ر.س.',
    minorSingle: 'Halalah',
    minorPlural: 'Halalahs',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
  },
  // USD: {
  //   name: 'United States Dollar',
  //   demonym: 'US',
  //   majorSingle: 'Dollar',
  //   majorPlural: 'Dollars',
  //   ISOnum: 840,
  //   symbol: '$',
  //   symbolNative: '$',
  //   minorSingle: 'Cent',
  //   minorPlural: 'Cents',
  //   ISOdigits: 2,
  //   decimals: 2,
  //   numToBasic: 100,
  // },
};

export const currencyList = Object.keys(currencyOptions);
